import React, { useEffect } from 'react';
import Loading from '../../../core/layouts/main/loading/loading';
import Layout from '../../../core/layouts/main';
import { Tabs, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AccountController } from '../../../core/config/controllers/AccountController';
import { VehicleController } from '../../../core/config/controllers/VehicleController';
import VehicleModal from './components/VehicleModal';
import ManualSubscriptionModal from './components/ManualSubscriptionModal';
import Storage from '../../../core/config/helpers/Storage';
import { AddressesController } from '../../../core/config/controllers/AddressesController';
import { SubscriptionsController } from '../../../core/config/controllers/SubscriptionController';
import { FeeController } from '../../../core/config/controllers/FeeController';
import { DateHelper } from '../../../core/config/helpers/DateHelper';
import { MoneyMask } from '../../../core/config/helpers/MoneyHelper';

export default function User() {

    const [data, setData] = React.useState({});
    const [showModal, setShowModal] = React.useState(false);
    const [showManualSubscriptionModal, setShowManualSubscriptionModal] = React.useState(false);
    const [selectedVehicle, setSelectedVehicle] = React.useState({});
    const [selectedSubscription, setSelectedSubscription] = React.useState({});

    const [vehicles, setVehicles] = React.useState([]);
    const [addresses, setAddresses] = React.useState([]);
    const [subscription, setSubscription] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [userId, setUserId] = React.useState(null);

    useEffect(() => {
        loadUserData();
    }, []);

    useEffect(() => {
        Storage.isAuthenticated();
    }, []);

    function loadUserData() {
        setLoading(true);
        // Extract query params from hash for hash-based routing
        let userIdFromUrl = null;
        const hash = window.location.hash;
        if (hash.includes('?')) {
            const queryString = hash.substring(hash.indexOf('?') + 1);
            const params = new URLSearchParams(queryString);
            userIdFromUrl = params.get('userId');
        }
        console.log('Id:', userIdFromUrl)
        setUserId(userIdFromUrl);

        if (userIdFromUrl) {
            AccountController.GetUser(userIdFromUrl).then((userData) => {
                console.log('Dados do usuário:', userData);
                if (userData) {
                    setData(userData)
                    setLoading(false)
                } else {
                    toast.error('Usuário não encontrado')
                    setLoading(false)
                }
            }).catch((error) => {
                console.error('Erro ao carregar dados do usuário:', error)
                toast.error('Erro ao carregar dados do usuário: ' + error.message)
                setLoading(false)
            });

            VehicleController.ListByOwner(userIdFromUrl, (vehicles) => {
                console.log('Veículos do usuário:', vehicles, userIdFromUrl);
                setVehicles(vehicles);
            }).catch((error) => {
                console.error('Erro ao carregar veículos do usuário:', error);
                toast.error('Erro ao carregar veículos do usuário: ' + error.message);
            });

            AddressesController.List(userIdFromUrl, (addresses) => {
                console.log('Endereços do usuário:', addresses);
                setAddresses(addresses);
            }).catch((error) => {
                console.error('Erro ao carregar endereços do usuário:', error);
                toast.error('Erro ao carregar endereços do usuário: ' + error.message);
            });
            FeeController.List(async (plans) => {

                await SubscriptionsController.List(userIdFromUrl, (subscriptions) => {
                    console.log('Assinaturas do usuário:', subscriptions);
                    for(let s of subscriptions){
                        s.plan = plans.find(p => p.id === s.planId);
                    }
                    // Sort subscriptions by newest first (currentPeriodStart descending)
                    subscriptions.sort((a, b) => {
                        const dateA = a.currentPeriodStart?.toDate?.() || new Date(a.currentPeriodStart);
                        const dateB = b.currentPeriodStart?.toDate?.() || new Date(b.currentPeriodStart);
                        return dateB - dateA;
                    });
                    setSubscription(subscriptions);
                }).catch((error) => {
                    console.error('Erro ao carregar assinaturas do usuário:', error);
                    toast.error('Erro ao carregar assinaturas do usuário: ' + error.message);
                });
            })
        } else {
            toast.error('ID do usuário não encontrado na URL');
            setLoading(false);
        }
    }

    function openVehicle(vehicle) {
        setSelectedVehicle(vehicle);
        setShowModal(true);
    }

    function handleSubscriptionUpdated() {
        // Reload subscriptions after manual subscription is created/updated/canceled
        loadUserData();
    }

    return (
        <Layout>
            {loading ? (
                <Loading />
            ) : (
                <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
                        <img
                            src={data.photo_url || 'assets/media/avatar10.jpg'}
                            alt="Foto do usuário"
                            style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', marginRight: 24 }}
                        />
                        <div>
                            <h2 style={{ margin: 0 }}>{data.display_name || 'Nome do Usuário'}</h2>
                            <p style={{ margin: '8px 0' }}>{data.email || 'email@exemplo.com'}</p>
                            <p style={{ margin: 0 }}>{data.phone_number || '(00) 00000-0000'}</p>
                        </div>
                        <div className='text-right' style={{ marginLeft: 'auto' }}>
                            <p style={{ margin: '8px 0' }}>{data.email || 'Nenhum plano Ativo'}</p>
                            <p style={{ margin: 0 }}>{vehicles.length > 0 ? `${vehicles.length} Veículos cadastrados` : 'Nenhum veículo cadastrado'}</p>
                        </div>
                    </div>
                    <Tabs defaultActiveKey={"profile"} id="user-tabs" className="mb-3">
                        <Tabs.Tab eventKey="profile" title="Perfil">
                            <div className='content-heading'>
                                <h3>Perfil do Usuário</h3>
                            </div>
                            <table className='table table-striped table-hover'>
                                <tbody>
                                    <tr>
                                        <td>Nome</td>
                                        <td>{data.display_name || 'Nome não informado'}</td>
                                    </tr>
                                    <tr>
                                        <td>Email</td>
                                        <td>{data.email || 'Email não informado'}</td>
                                    </tr>
                                    <tr>
                                        <td>Telefone</td>
                                        <td>{data.phone_number || 'Telefone não informado'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Tabs.Tab>
                        <Tabs.Tab eventKey="vehicles" title="Veículos">
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
                                {vehicles && vehicles.length > 0 ? (
                                    vehicles.map((vehicle, idx) => (
                                        <div
                                            key={vehicle.plate || idx}
                                            className='border border-2x cursor'
                                            style={{
                                                background: '#f7f7f7',
                                                borderRadius: 24,
                                                padding: 24,
                                                minWidth: 340,
                                                maxWidth: 360,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                            }}
                                            onClick={() => openVehicle(vehicle)}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontWeight: 600, fontSize: 22, color: '#232323' }}>
                                                        {vehicle.manufacturer || 'Fabricante'}
                                                    </div>
                                                    <div style={{ fontWeight: 600, fontSize: 22, color: '#232323' }}>
                                                        {vehicle.model || 'Modelo'}
                                                    </div>
                                                </div>
                                                <img
                                                    src={'assets/media/carro.png'}
                                                    alt="Carro"
                                                    style={{ width: 140, height: 60, objectFit: 'contain' }}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                <span style={{ display: 'flex', alignItems: 'center', marginRight: 16, color: '#888', fontWeight: 500 }}>
                                                    <span style={{ marginRight: 6 }}>
                                                        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M12 2l4 8H8l4-8zm0 20a8 8 0 100-16 8 8 0 000 16z" fill="#888" /></svg>
                                                    </span>
                                                    {'> 870km'}
                                                </span>
                                                <span style={{ display: 'flex', alignItems: 'center', color: '#888', fontWeight: 500 }}>
                                                    <span style={{ marginRight: 6 }}>
                                                        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M7 2v2H3v2h1v14a2 2 0 002 2h10a2 2 0 002-2V6h1V4h-4V2H7zm0 4h10v14H7V6z" fill="#888" /></svg>
                                                    </span>
                                                    50L
                                                </span>
                                            </div>
                                            <div style={{ fontWeight: 600, color: '#232323', fontSize: 17 }}>
                                                Assinatura pendente
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ color: '#888', fontSize: 16 }}>{console.log(data.vehicles)}Nenhum veículo cadastrado</div>
                                )}
                            </div>
                        </Tabs.Tab>
                        <Tabs.Tab eventKey="addresses" title="Endereços">
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
                                <table className='table table-hover table-striped'>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Rua</th>
                                            <th>Cidade</th>
                                            <th>Estado</th>
                                            <th>CEP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {addresses && addresses.length > 0 ? (
                                            addresses.map((address, idx) => (
                                                <tr key={idx}>
                                                    <td>{address.id}</td>
                                                    <td>{address?.address?.address}</td>
                                                    <td>{address?.address?.city}</td>
                                                    <td>{address?.address?.state}</td>
                                                    <td>{address?.address?.zipCode}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr style={{ color: '#888', fontSize: 16 }}><td className='text-center' colSpan={5}>Nenhum endereço cadastrado</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Tabs.Tab>
                        <Tabs.Tab eventKey="signatures" title="Assinaturas">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className='content-heading'>
                                    <h3>Assinaturas do Usuário</h3>
                                </div>
                                <Button 
                                    variant="primary" 
                                    onClick={() => setShowManualSubscriptionModal(true)}
                                    disabled={!userId}
                                >
                                    Gerenciar Assinatura Manual
                                </Button>
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
                                <table className='table table-hover table-striped'>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Tipo</th>
                                            <th>Status</th>
                                            <th>Início</th>
                                            <th>Fim</th>
                                            <th>Valor (R$)</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subscription && subscription.length > 0 ? (
                                            subscription.map((plan, idx) => (
                                                <tr key={idx}>
                                                    <td>{plan.id}</td>
                                                    <td>
                                                        <span className={`badge ${plan?.subscription_type === 'stripe' ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                            {plan?.subscription_type === 'stripe' ? 'Stripe' : 'Manual'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${
                                                            plan?.status === 'active' ? 'bg-success' : 
                                                            plan?.status === 'canceled' ? 'bg-danger' : 
                                                            plan?.status === 'expired' ? 'bg-warning' : 'bg-secondary'
                                                        }`}>
                                                            {plan?.status}
                                                        </span>
                                                    </td>
                                                    <td>{DateHelper.OnlyDateTranslate(plan?.currentPeriodStart)}</td>
                                                    <td>{DateHelper.OnlyDateTranslate(plan?.currentPeriodEnd)}</td>
                                                    <td>{plan && MoneyMask(plan?.plan?.price)}</td>

                                                    <td>
                                                        {/* <button className='btn btn-dual' onClick={() => setSelectedSubscription(plan) | setShowManualSubscriptionModal(true)}><i className='far fa-edit'/></button> */}
                                                        <button className='btn btn-dual' onClick={() => {
                                                        
                                                        if(window.confirm('Tem certeza que deseja cancelar esta assinatura?')){
                                                        SubscriptionsController.Delete(userId, plan.id);
                                                        setTimeout(() => {
                                                            handleSubscriptionUpdated();
                                                        }, 2000);
                                                        }
                                                        }}><i className='si si-close'/></button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr style={{ color: '#888', fontSize: 16 }}><td className='text-center' colSpan={6}>Nenhuma assinatura cadastrada</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Tabs.Tab>
                    </Tabs>

                </div>
            )}
            <VehicleModal
                show={showModal}
                onHide={() => setShowModal(false) | setSelectedVehicle({})}
                vehicle={selectedVehicle}
            />
            <ManualSubscriptionModal
                show={showManualSubscriptionModal}
                onHide={() => setShowManualSubscriptionModal(false)}
                userId={userId}
                userSubscriptions={subscription}
                onSubscriptionUpdated={handleSubscriptionUpdated}
            />
        </Layout>
    )
}